(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["df-product-project"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('df-project')) {
  class DFProject extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.product = JSON.parse(this.querySelector('[data-df-product]').textContent);
      this.labels = JSON.parse(this.querySelector('[data-df-labels]').textContent);
      this.root = this.closest('[data-section-type="product"]');
      this.variant = this.product.variants.find(v => String(v.id) === this.dataset.initialVariant);
      this.area = this.querySelector('[data-area]');
      this.waste = this.querySelector('[data-waste]');
      this.coverage = this.querySelector('[data-coverage]');
      this.quote = this.querySelector('.df-quote');
      const on = (el, event, callback) => el.addEventListener(event, callback, {signal:this.controller.signal});
      const doc = new DOMParser().parseFromString(this.product.description || '', 'text/html');
      const source = doc.body.textContent.replace(/\s+/g, ' ');
      const specs = this.querySelector('[data-quick-specs]');
      const specPatterns = [
        ['Width', /(?:width|wide)\s*(?:\([^)]*\))?\s*[:：]?\s*(\d+(?:[.\/]\d+)?\s*(?:inches|inch|in\b|mm|["″]))/i],
        ['Thickness', /(?:thickness|thick)\s*(?:\([^)]*\))?\s*[:：]?\s*(\d+(?:[.\/]\d+)?\s*(?:inches|inch|in\b|mm|["″]))/i],
        ['Wear layer', /wear\s*layer\s*(?:\([^)]*\))?\s*[:：]?\s*(\d+(?:\.\d+)?\s*(?:mm|mil))/i]
      ];
      for (const [label, pattern] of specPatterns) {
        const match = source.match(pattern);
        if (!match) continue;
        const item = document.createElement('div');
        const name = document.createElement('span'); name.textContent = label;
        const value = document.createElement('strong'); value.textContent = match[1];
        item.append(name, value); specs.append(item);
      }
      specs.hidden = !specs.children.length;
      const patterns = [/(\d+(?:\.\d+)?)\s*(?:sq\.?\s*ft\.?|square\s*feet|sqft)\s*(?:\/|per)\s*(?:box|carton)/ig, /(?:sq\.?\s*ft\.?|square\s*feet|sqft)\s*(?:\/|per)\s*(?:box|carton)\s*\)?\s*[:\-]?\s*(\d+(?:\.\d+)?)/ig];
      const values = [...new Set(patterns.flatMap(pattern => [...source.matchAll(pattern)].map(m => Number(m[1]))))];
      if (values.length === 1 && values[0] > 0 && values[0] < 1000) this.coverage.value = values[0];
      this.querySelector('[data-calculator]').hidden = false;
      this.querySelector('[data-request-sample]').hidden = false;
      this.querySelector('[data-mobile-bar]').hidden = false;
      for (const input of [this.area,this.waste,this.coverage]) on(input,'input',() => this.update());
      on(this.querySelector('[data-apply]'),'click',() => this.apply());
      on(this.querySelector('[data-request-sample]'),'click',() => {
        this.querySelector('[data-quote-service]').value = this.querySelector('[data-sample-option]').value;
        this.openQuote();
      });
      on(document,'product:variant-change',e => {
        const variant = e.detail && e.detail.variant;
        if (variant && this.product.variants.some(v => v.id === variant.id)) {
          this.variant = variant;
          this.update();
        }
      });
      on(this.root,'change',e => {
        if (e.target.matches('[name="id"]')) {
          const variant = this.product.variants.find(v => String(v.id) === e.target.value);
          if (variant) {this.variant = variant;this.update();}
        }
      });
      this.update();
      if (this.querySelector('[data-contact-success],[data-contact-errors]')) this.quote.open = true;
    }
    disconnectedCallback() {this.controller?.abort();this.controller = null;}
    openQuote() {
      this.quote.open = true;
      this.quote.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
      this.querySelector('[name="contact[name]"]').focus({preventScroll:true});
    }
    calculate() {
      const area=Number(this.area.value), coverage=Number(this.coverage.value), waste=Number(this.waste.value);
      if (!Number.isFinite(area)||!Number.isFinite(coverage)||!Number.isFinite(waste)||area<=0||area>1000000||coverage<=0||coverage>10000||waste<0||waste>15) return null;
      const boxes=Math.ceil((area*(1+waste/100))/coverage - 1e-10);
      if (!Number.isSafeInteger(boxes)||boxes<1||boxes>1000000) return null;
      return {boxes,coverage:boxes*coverage};
    }
    isBoxVariant() {
      const title=this.variant?.title || '';
      if (/sample/i.test(title) || this.dataset.cartUnit==='manual') return false;
      return this.dataset.cartUnit==='boxes' || /\b(?:box|carton)\b/i.test(title) && !/(?:square\s*foot|sq\.?\s*ft|sqft)/i.test(title);
    }
    update() {
      this.result=this.calculate();
      const sample=/sample/i.test(this.variant?.title || '');
      this.querySelector('[data-totals]').hidden=!this.result;
      const prompt=this.querySelector('[data-calc-prompt]');
      prompt.hidden=Boolean(this.result);
      prompt.textContent=this.area.value && this.coverage.value ? this.labels.invalid : this.labels.empty;
      if (this.result) {
        this.querySelector('[data-box-count]').textContent=this.result.boxes.toLocaleString();
        this.querySelector('[data-total-coverage]').textContent=this.result.coverage.toLocaleString(undefined,{maximumFractionDigits:2});
      }
      this.querySelector('[data-apply]').hidden=!(this.result && this.isBoxVariant() && this.variant?.available);
      this.querySelector('[data-cart-note]').textContent=sample?this.labels.sample:this.labels.separate;
      if (this.area.value) this.querySelector('[data-quote-area]').value=this.area.value;
      this.querySelector('[data-quote-variant]').value=this.variant?.title || '';
      this.querySelector('[data-quote-boxes]').value=this.result?.boxes || '';
      this.querySelector('[data-quote-coverage]').value=this.result?this.result.coverage.toFixed(2):'';
    }
    apply() {
      this.update();
      if (!this.result || !this.isBoxVariant() || !this.variant?.available) return;
      const visible=this.root.querySelector('[data-quantity-input]');
      if (visible) {visible.value=this.result.boxes;visible.dispatchEvent(new Event('change',{bubbles:true}));}
      this.root.querySelectorAll('form[data-product-form] [name="quantity"]').forEach(input => {input.value=this.result.boxes;});
      this.querySelector('[data-cart-note]').textContent=this.labels.applied;
    }
  }
  customElements.define('df-project', DFProject);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["df-store-finder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('df-store-finder')) {
  class DFStoreFinder extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const form = this.querySelector('form');
      const input = this.querySelector('input[name="zip"]');
      const error = this.querySelector('[role="alert"]');
      const result = this.querySelector('.df-store-finder__result');
      const showResult = () => {
        const zip = input.value.trim();
        if (!/^\d{5}(?:[ -]\d{4})?$/.test(zip) || /^0{5}(?:[ -]\d{4})?$/.test(zip)) {
          result.hidden = true;
          error.textContent = this.dataset.invalid;
          error.hidden = false;
          input.setAttribute('aria-invalid', 'true');
          input.focus();
          return;
        }
        input.removeAttribute('aria-invalid');
        error.hidden = true;
        const url = new URL(this.querySelector('[data-directions]').href);
        url.searchParams.set('origin', zip.slice(0, 5) + ', USA');
        this.querySelector('[data-directions]').href = url.toString();
        result.hidden = false;
      };
      form.addEventListener('submit', event => { event.preventDefault(); showResult(); }, {signal: this.controller.signal});
      input.addEventListener('input', () => { result.hidden = true; error.hidden = true; input.removeAttribute('aria-invalid'); }, {signal: this.controller.signal});
      const zip = new URLSearchParams(window.location.search).get('zip');
      if (zip && /^\d{5}(?:[ -]\d{4})?$/.test(zip)) { input.value = zip; showResult(); }
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  }
  customElements.define('df-store-finder', DFStoreFinder);
}
  } catch(e) { console.error(e); }
})();

})();
